(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feedback-form"] && !Shopify.designMode) return;
  try {
    
  class FeedbackFormSection {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('.feedback-form__form');
      this.messageField = section.querySelector('[data-feedback-message]');
      this.productInput = section.querySelector('[data-feedback-product-input]');
      this.imageUrlInput = section.querySelector('[data-feedback-image-url-input]');
      this.submitButton = section.querySelector('[data-feedback-submit]');
      this.isSubmitting = false;
      this.allowNativeSubmit = false;
      this.selectedProduct = null;
      this.selectedImageFile = null;
      this.products = [];

      this.initProductPicker();
      this.initImageUpload();
      this.bindEvents();
    }

    initProductPicker() {
      this.productPicker = this.section.querySelector('[data-feedback-product-picker]');
      if (!this.productPicker) return;

      this.productTrigger = this.productPicker.querySelector('[data-feedback-product-trigger]');
      this.productDropdown = this.productPicker.querySelector('[data-feedback-product-dropdown]');
      this.productList = this.productPicker.querySelector('[data-feedback-product-list]');
      this.productDisplay = this.productPicker.querySelector('[data-feedback-product-display]');
      this.productSearch = this.productPicker.querySelector('[data-feedback-product-search]');
      this.productLoading = this.productPicker.querySelector('[data-feedback-product-loading]');
      this.productEmpty = this.productPicker.querySelector('[data-feedback-product-empty]');
      this.productBackdrop = this.productPicker.querySelector('[data-feedback-product-backdrop]');
      this.productClose = this.productPicker.querySelector('[data-feedback-product-close]');
      this.productError = this.productPicker.querySelector('[data-feedback-product-error]');
      this.productPlaceholder = this.productDisplay?.querySelector('.feedback-form__product-placeholder')?.textContent || 'Select a product';
      this.productRequiredError = this.section.dataset.productRequiredError || 'Please select a product.';
      this.noImageMessage = this.section.dataset.noImageMessage || 'No image provided by customer';
      this.imgbbKey = this.section.dataset.imgbbKey || '';
      this.googleSheetsUrl = this.section.dataset.googleSheetsUrl || '';
      this.googleSheetsSecret = this.section.dataset.googleSheetsSecret || '';
      this.googleSheetsEnabled = this.section.dataset.googleSheetsEnabled === 'true';

      this.loadAllProducts();
    }

    initImageUpload() {
      this.imageUpload = this.section.querySelector('[data-feedback-image-upload]');
      if (!this.imageUpload) return;

      this.imageInput = this.imageUpload.querySelector('[data-feedback-image-input]');
      this.imagePreview = this.imageUpload.querySelector('[data-feedback-image-preview]');
      this.imagePreviewImg = this.imageUpload.querySelector('[data-feedback-image-preview-img]');
      this.imageRemove = this.imageUpload.querySelector('[data-feedback-image-remove]');
      this.imageLabelText = this.imageUpload.querySelector('[data-feedback-image-label-text]');
      this.defaultImageLabel = this.imageLabelText?.textContent || 'Choose an image';
    }

    bindEvents() {
      if (this.productTrigger) {
        this.productTrigger.addEventListener('click', () => this.toggleProductDropdown());
      }

      if (this.productSearch) {
        this.productSearch.addEventListener('input', () => this.filterProducts(this.productSearch.value));
      }

      if (this.productPicker) {
        document.addEventListener('click', (event) => {
          if (!this.productPicker.contains(event.target)) {
            this.closeProductDropdown();
          }
        });
      }

      if (this.productBackdrop) {
        this.productBackdrop.addEventListener('click', () => this.closeProductDropdown());
      }

      if (this.productClose) {
        this.productClose.addEventListener('click', () => this.closeProductDropdown());
      }

      if (this.imageInput) {
        this.imageInput.addEventListener('change', (event) => this.handleImageSelect(event));
      }

      if (this.imageRemove) {
        this.imageRemove.addEventListener('click', () => this.clearImage());
      }

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => this.handleSubmit());
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        this.form.setAttribute('novalidate', 'novalidate');
      }
    }

    async loadAllProducts() {
      const products = [];
      let page = 1;
      let hasMore = true;

      try {
        while (hasMore) {
          const response = await fetch(`/products.json?limit=250&page=${page}`);
          if (!response.ok) break;

          const data = await response.json();
          const batch = (data.products || []).filter((product) => this.isActiveProduct(product));

          products.push(...batch);
          hasMore = batch.length === 250;
          page += 1;
        }
      } catch (error) {
        products.length = 0;
      }

      this.products = products.sort((a, b) => a.title.localeCompare(b.title));
      this.renderProducts(this.products);

      if (this.productLoading) {
        this.productLoading.hidden = true;
      }

      if (this.productEmpty) {
        this.productEmpty.hidden = this.products.length > 0;
      }
    }

    isActiveProduct(product) {
      return Boolean(product && product.published_at);
    }

    renderProducts(products) {
      if (!this.productList) return;

      this.productList.innerHTML = '';

      products.forEach((product) => {
        const imageUrl = this.getProductImage(product);
        const option = document.createElement('li');
        option.innerHTML = `
          <button
            type="button"
            class="feedback-form__product-option${this.selectedProduct?.id === product.id ? ' is-selected' : ''}"
            data-product-id="${product.id}"
            role="option"
          >
            <img src="${imageUrl}" alt="" width="44" height="44" loading="lazy">
            <span>${this.escapeHtml(product.title)}</span>
          </button>
        `;

        option.querySelector('button').addEventListener('click', () => this.selectProduct(product, imageUrl));
        this.productList.appendChild(option);
      });

      if (this.productEmpty) {
        this.productEmpty.hidden = products.length > 0;
      }
    }

    getProductImage(product) {
      const featured = product.featured_image || product.images?.[0];
      if (!featured) {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44"%3E%3Crect width="44" height="44" fill="%23f5f5f5"/%3E%3C/svg%3E';
      }

      return featured.src || featured;
    }

    filterProducts(query) {
      const normalized = query.trim().toLowerCase();
      const filtered = normalized
        ? this.products.filter((product) => product.title.toLowerCase().includes(normalized))
        : this.products;

      this.renderProducts(filtered);
    }

    selectProduct(product, imageUrl) {
      this.selectedProduct = product;

      if (this.productInput) {
        this.productInput.value = product.title;
        this.productInput.disabled = false;
        this.productInput.removeAttribute('disabled');
      }

      if (this.productDisplay) {
        this.productDisplay.innerHTML = `
          <img src="${imageUrl}" alt="" width="40" height="40">
          <span>${this.escapeHtml(product.title)}</span>
        `;
      }

      this.clearProductError();
      this.closeProductDropdown();
      this.renderProducts(this.products);
    }

    showProductError() {
      if (this.productError) {
        this.productError.hidden = false;
        this.productError.textContent = this.productRequiredError;
      }

      if (this.productTrigger) {
        this.productTrigger.classList.add('is-invalid');
        this.productTrigger.setAttribute('aria-invalid', 'true');
        this.productTrigger.focus();
      }

      this.openProductDropdown();
    }

    clearProductError() {
      if (this.productError) {
        this.productError.hidden = true;
      }

      if (this.productTrigger) {
        this.productTrigger.classList.remove('is-invalid');
        this.productTrigger.setAttribute('aria-invalid', 'false');
      }
    }

    clearProductSelection() {
      this.selectedProduct = null;

      if (this.productInput) {
        this.productInput.value = '';
        this.productInput.disabled = true;
      }

      if (this.productDisplay) {
        this.productDisplay.innerHTML = `<span class="feedback-form__product-placeholder">${this.escapeHtml(this.productPlaceholder)}</span>`;
      }
    }

    isMobilePicker() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    openProductDropdown() {
      if (!this.productDropdown || !this.productTrigger || !this.productPicker) return;

      this.productDropdown.hidden = false;
      this.productTrigger.setAttribute('aria-expanded', 'true');
      this.productPicker.classList.add('is-open');

      if (this.isMobilePicker()) {
        if (this.productBackdrop) {
          this.productBackdrop.hidden = false;
        }
        document.body.style.overflow = 'hidden';
      }

      if (this.productSearch) {
        this.productSearch.value = '';
        this.filterProducts('');
        this.productSearch.focus();
      }
    }

    toggleProductDropdown() {
      if (!this.productDropdown || !this.productTrigger) return;

      if (this.productDropdown.hidden) {
        this.openProductDropdown();
      } else {
        this.closeProductDropdown();
      }
    }

    closeProductDropdown() {
      if (!this.productDropdown || !this.productTrigger || !this.productPicker) return;

      this.productDropdown.hidden = true;
      this.productTrigger.setAttribute('aria-expanded', 'false');
      this.productPicker.classList.remove('is-open');

      if (this.productBackdrop) {
        this.productBackdrop.hidden = true;
      }

      document.body.style.overflow = '';
    }

    handleImageSelect(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        event.target.value = '';
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        event.target.value = '';
        alert('Please choose an image smaller than 5MB.');
        return;
      }

      this.selectedImageFile = file;

      const reader = new FileReader();
      reader.onload = () => {
        if (this.imagePreviewImg) {
          this.imagePreviewImg.src = reader.result;
          this.imagePreviewImg.alt = file.name;
        }
        if (this.imagePreview) {
          this.imagePreview.hidden = false;
        }
        if (this.imageLabelText) {
          this.imageLabelText.textContent = file.name;
        }
      };
      reader.readAsDataURL(file);
    }

    clearImage() {
      this.selectedImageFile = null;

      if (this.imageInput) {
        this.imageInput.value = '';
      }
      if (this.imageUrlInput) {
        this.imageUrlInput.value = this.noImageMessage;
      }
      if (this.imagePreview) {
        this.imagePreview.hidden = true;
      }
      if (this.imagePreviewImg) {
        this.imagePreviewImg.src = '';
        this.imagePreviewImg.alt = '';
      }
      if (this.imageLabelText) {
        this.imageLabelText.textContent = this.defaultImageLabel;
      }
    }

    async compressImage(file) {
      const imageBitmap = await createImageBitmap(file);
      const maxSize = 1200;
      const scale = Math.min(1, maxSize / Math.max(imageBitmap.width, imageBitmap.height));
      const width = Math.round(imageBitmap.width * scale);
      const height = Math.round(imageBitmap.height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const context = canvas.getContext('2d');
      context.drawImage(imageBitmap, 0, 0, width, height);

      const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/jpeg', 0.85);
      });

      imageBitmap.close();
      return blob || file;
    }

    async uploadImage(file) {
      const compressed = await this.compressImage(file);

      if (this.imgbbKey) {
        const base64 = await this.fileToBase64(compressed);
        const body = new URLSearchParams();
        body.append('image', base64);

        const response = await fetch(`https://api.imgbb.com/1/upload?key=${encodeURIComponent(this.imgbbKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: body.toString()
        });

        if (!response.ok) {
          throw new Error('Image upload failed');
        }

        const result = await response.json();
        const url = result?.data?.url || result?.data?.display_url;
        if (!url) {
          throw new Error('Invalid upload response');
        }

        return url;
      }

      const formData = new FormData();
      formData.append('file', compressed, file.name.replace(/\.[^.]+$/, '.jpg'));

      const response = await fetch('https://0x0.st', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Image upload failed');
      }

      const url = (await response.text()).trim();
      if (!url.startsWith('http')) {
        throw new Error('Invalid upload response');
      }

      return url;
    }

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          if (typeof result !== 'string') {
            reject(new Error('Could not read image'));
            return;
          }
          resolve(result.replace(/^data:[^;]+;base64,/, ''));
        };
        reader.onerror = () => reject(new Error('Could not read image'));
        reader.readAsDataURL(file);
      });
    }

    async sendToGoogleSheets(payload) {
      if (!this.googleSheetsEnabled || !this.googleSheetsUrl) {
        return;
      }

      const body = new URLSearchParams();
      body.append('timestamp', payload.timestamp);
      body.append('name', payload.name);
      body.append('email', payload.email);
      body.append('product', payload.product);
      body.append('feedback', payload.feedback);
      body.append('image_url', payload.imageUrl);
      body.append('page_url', payload.pageUrl);

      if (this.googleSheetsSecret) {
        body.append('secret', this.googleSheetsSecret);
      }

      await fetch(this.googleSheetsUrl, {
        method: 'POST',
        mode: 'no-cors',
        body
      });
    }

    async handleSubmit(event) {
      if (!this.messageField || !this.form) return;

      if (this.allowNativeSubmit) {
        this.allowNativeSubmit = false;
        return;
      }

      if (event) {
        event.preventDefault();
      }

      if (this.isSubmitting) {
        return;
      }

      const feedback = this.messageField.value.trim();
      if (!feedback) {
        this.messageField.focus();
        this.messageField.reportValidity();
        return;
      }

      if (!this.hasSelectedProduct()) {
        this.showProductError();
        return;
      }

      this.clearProductError();

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.submitButton.dataset.loadingText || 'Submitting...';
      }

      this.prepareImageField();

      if (this.selectedImageFile) {
        try {
          const imageUrl = await this.uploadImage(this.selectedImageFile);
          if (this.imageUrlInput) {
            this.imageUrlInput.value = imageUrl;
          }
        } catch (error) {
          if (this.imageUrlInput) {
            this.imageUrlInput.value = 'Image upload failed. Please follow up with the customer.';
          }
        }
      }

      if (!this.hasSelectedProduct()) {
        this.resetSubmitButton();
        this.showProductError();
        return;
      }

      const nameField = this.form.querySelector('[name="contact[Full Name]"]');
      const emailField = this.form.querySelector('[name="contact[email]"]');

      if (!nameField?.value?.trim()) {
        this.resetSubmitButton();
        nameField?.focus();
        nameField?.reportValidity();
        return;
      }

      if (!emailField?.value?.trim()) {
        this.resetSubmitButton();
        emailField?.focus();
        emailField?.reportValidity();
        return;
      }

      this.prepareImageField();

      try {
        await this.sendToGoogleSheets({
          timestamp: new Date().toISOString(),
          name: nameField.value.trim(),
          email: emailField.value.trim(),
          product: this.productInput?.value?.trim() || '',
          feedback,
          imageUrl: this.imageUrlInput?.value?.trim() || this.noImageMessage,
          pageUrl: window.location.href
        });
      } catch (error) {
        // Do not block Shopify submission if Google Sheets fails.
      }

      this.messageField.value = feedback;
      this.isSubmitting = true;
      this.allowNativeSubmit = true;
      this.form.requestSubmit();
    }

    prepareImageField() {
      if (!this.imageUrlInput) return;

      if (this.selectedImageFile && this.imageUrlInput.value.includes('http')) {
        return;
      }

      if (!this.selectedImageFile) {
        this.imageUrlInput.value = this.noImageMessage;
      }
    }

    hasSelectedProduct() {
      if (!this.productInput || this.productInput.disabled) {
        return false;
      }

      const product = this.productInput.value.trim();
      return Boolean(product && this.selectedProduct);
    }

    resetSubmitButton() {
      if (!this.submitButton) return;

      this.submitButton.disabled = false;
      this.submitButton.textContent = this.submitButton.dataset.defaultText || 'Submit feedback';
    }

    escapeHtml(value) {
      return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }
  }

  document.querySelectorAll('.feedback-form').forEach((section) => {
    new FeedbackFormSection(section);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.feedback-form');
    if (section) {
      new FeedbackFormSection(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
